import { ChangeDetectionStrategy, Component, computed, inject, Signal, ViewEncapsulation } from '@angular/core';
import { FiQuizEditorStoreService } from '../fi-quiz-editor-store.service';
import { FiComponentsContainer } from '@fi-app/shared/fi-components-container';
import { Animations } from '@fi-app/shared/utils/animations';

@Component({
    selector: 'fi-quiz-editor-tab',
    templateUrl: './quiz-editor-tab.component.html',
    styleUrls: ['./quiz-editor-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-editor-tab' },
    standalone: false,
    providers: [{ provide: FiComponentsContainer, useExisting: FiQuizEditorTabComponent }],
    animations: [Animations.fadeHeight()],
})
export class FiQuizEditorTabComponent extends FiComponentsContainer {
    private fiQuizEditorStoreService = inject(FiQuizEditorStoreService);
    protected quizQuestions = computed(() => this.fiQuizEditorStoreService.currentQuizData().Questions);
}
